// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"448":"d3a00919","786":"2aaf6015"}[chunkId] + ".chunk.js";
};